import React from 'react';
import QuickPick from '../../../../../../quick-pick/live-mode';

class NewQuickPick extends React.Component {
  render() {
    return <QuickPick {...this.props} closeButton={true} />;
  }
}

export default NewQuickPick;
